export * from './admin-layout.component';



// WEBPACK FOOTER //
// ./src/app/containers/admin-layout/index.ts